import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import _ from "lodash";
import { Grid } from "semantic-ui-react";
import { Div } from "@components/Generics.react";

import { useParams } from "react-router-dom";
import ArticleCard from "@components/ArticleCard.react";
import MasterLayout from "@layouts/MasterLayout.react";
import RecommendedArticles from "@components/RecommendedArticles.react";
import FilterField from "@components/FilterField.react";

export default function ArticleListing(props) {
    const { name } = useParams();
    const taggedList = useSelector((state) => state.articles.taggedList);
    const { t } = useTranslation("common");
    const sortedArticles = useMemo(
        () => _.orderBy(taggedList[name]?.articles, ["priority"], ["desc"]),
        [taggedList, name]
    );
    const [filteredArticles, setFilteredArticles] = useState(sortedArticles);

    const isPortrait = window.innerHeight > window.innerWidth;
    // ========================= Render Function =================================
    return (
        <MasterLayout
            title={"Tag Listing"}
            mainPanel={
                <Div padded>
                    <Div large padTop gutter uppercase>
                        {name}
                    </Div>
                    <Div small={!isPortrait} trench>
                        <FilterField
                            srcData={sortedArticles}
                            setResult={setFilteredArticles}
                            searchKey="name"
                        />
                    </Div>
                    <Grid columns={isPortrait ? 1 : 2}>
                        <Grid.Row>
                            {_.map(filteredArticles, (article, idx) => {
                                return (
                                    <Grid.Column
                                        key={`article-${article._id}-${idx}`}
                                    >
                                        <ArticleCard article={article} />
                                        <br />
                                    </Grid.Column>
                                );
                            })}
                        </Grid.Row>
                    </Grid>
                </Div>
            }
            rightPanelName={t(`rightPanel.recommended`)}
            rightPanel={<RecommendedArticles />}
        />
    );
}
